module.exports = __webpack_public_path__ + "img/card-expiry-date.ccf10ccd.svg";